import { cloneDeep } from "lodash";
export class PricingRecord {
    id;
    entry;
    constructor(id, entry) {
        this.id = id;
        this.entry = entry;
    }
    get timestamp() {
        const timestamp = this.entry?.timestamp ?? null;
        if (timestamp && "toDate" in timestamp) {
            return timestamp.toDate();
        }
        return timestamp;
    }
    get isLoaded() {
        return this.entry !== undefined;
    }
    data() {
        return cloneDeep(this.entry);
    }
}
//# sourceMappingURL=base.js.map